import { GetBonusApplicantsQuery, BonusApplicantsResponse } from '@/types/bonus';
import apiSlice from './apiSlice';

/**
 * A campaign as the operator configured it, trimmed to the fields the deposit
 * sheet prices an amount with. `percentage` and `maxBonusAmount` together are
 * why a bigger deposit stops earning more: the award is the percentage, capped.
 */
export interface BonusOffer {
  id: number;
  category: 'JoiningBonus' | 'ReferralBonus' | 'DepositBonus';
  name: string;
  description: string | null;
  status: 'Active' | 'Inactive';
  startDate: string;
  endDate: string;
  minDepositAmount: number | null;
  maxBonusAmount: number | null;
  percentage: number | null;
  releaseType: string;
  /** How many steps the award is paid in; null or 1 means a single payout. */
  installments: number | null;
}

export interface BonusListResponse {
  bonuses: BonusOffer[];
  pagination: { currentPage: number; totalItems: number; totalPage: number; limit: number };
}

export const bonusApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBonusApplicants: builder.query<BonusApplicantsResponse, GetBonusApplicantsQuery>({
      query: (params) => ({
        url: '/bonuses/applicants/list',
        method: 'GET',
        params,
      }),
      //   providesTags: ['BonusApplicants'],
    }),

    // The campaign list itself. Public — GET /bonuses carries no auth guard, so
    // the deposit sheet can price the offer before the player has signed in.
    getBonuses: builder.query<
      BonusListResponse,
      { category?: string; status?: string; page?: number; limit?: number }
    >({
      query: (params) => ({
        url: '/bonuses',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetBonusApplicantsQuery, useGetBonusesQuery } = bonusApi;
